export default __webpack_public_path__ + "static/media/juegoconstancias_perder.32d9228f.png";